import { clearInputField } from '../../helpers';

export const addSupplementalDoc = ($form) => {
  let $addInvestorDocButton = $('#add_another_investor_document', $form);
  let $supplementalInvestorDocumentFields = $('.supplemental-investor-doc-fields', $form);
  let $removeInvestorDocButtons = $('.remove-document', $supplementalInvestorDocumentFields);

  let $addRepDocButton = $('#add_another_representitive_document', $form);
  let $supplementalRepDocumentFields = $('.supplemental-representitive-doc-fields', $form);
  let $removeRepDocButtons = $('.remove-document', $supplementalRepDocumentFields);

  addExtraDocFields($addInvestorDocButton, $supplementalInvestorDocumentFields);
  removeExtraDocFields($removeInvestorDocButtons, $addInvestorDocButton, $supplementalInvestorDocumentFields);

  addExtraDocFields($addRepDocButton, $supplementalRepDocumentFields);
  removeExtraDocFields($removeRepDocButtons, $addRepDocButton, $supplementalRepDocumentFields);
};

const addExtraDocFields = ($addButton, $docFields) => {
  $addButton.on('click', (e) => {
    e.preventDefault();

    let hiddenDocFields = $docFields.filter('.d-none');

    if (hiddenDocFields.length == 1) {
      $addButton.addClass('d-none');
    };

    hiddenDocFields.first().removeClass('d-none');
  });
};

const removeExtraDocFields = ($removeButtons, $addButton, $docFields) => {
  $removeButtons.on('click', (e) => {
    e.preventDefault();

    let $removeButton = $(e.target);
    let fields = $removeButton.closest($docFields);

    fields.addClass('d-none');

    $('input', fields).each((_, inputElement) => {
      clearInputField(inputElement);
    });

    $addButton.removeClass('d-none');
  });
};
